import { InnerMode } from './TextSection/enums';

export const REQUIRED_META_FIELDS = ['defaultSectionWrapperProps'];

export const BLOG_INNER_MAX_WIDTH = InnerMode.XXS;
